import { FieldErrors, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import {
  ChildYouthAthleteAccess,
  FamilyYouthAthleteAccess,
} from '../YouthAthleteAccess.types';
import YouthAthleteSection from '../YouthAthleteSection/YouthAthleteSection';

interface YouthAthleteSectionListProps {
  errors: FieldErrors<FamilyYouthAthleteAccess>;
  isDisabled: boolean;
  setValue: UseFormSetValue<FamilyYouthAthleteAccess>;
  showCanChat: boolean;
  watch: UseFormWatch<FamilyYouthAthleteAccess>;
  youthAthletes: ChildYouthAthleteAccess[];
}

export default function YouthAthleteSectionList({
  errors,
  isDisabled,
  setValue,
  showCanChat,
  watch,
  youthAthletes,
}: YouthAthleteSectionListProps) {
  const youthAthleteElements = youthAthletes.map((youthAthlete, idx) => {
    const { firstName, lastName, userId, email } = youthAthlete;
    return (
      <YouthAthleteSection
        firstName={firstName}
        lastName={lastName}
        isDisabled={isDisabled}
        userId={userId}
        email={watch(`youthAthletes.${idx}.email`)}
        canChat={watch(`youthAthletes.${idx}.canChat`)}
        emailReadOnly={!!email} // true if email exists on component load
        emailErrorMsg={errors.youthAthletes?.[idx]?.email?.message}
        hasYouthAthletePermission={watch(
          `youthAthletes.${idx}.hasYouthAthletePermission`
        )}
        showCanChat={showCanChat}
        onChangeEmail={(value) => setValue(`youthAthletes.${idx}.email`, value)}
        onChangePermission={(value) =>
          setValue(`youthAthletes.${idx}.hasYouthAthletePermission`, value)
        }
        onChangeChat={(value) =>
          setValue(`youthAthletes.${idx}.canChat`, value)
        }
        key={userId}
      />
    );
  });

  return <>{youthAthleteElements}</>;
}
